var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"unsubscribe"},[(_vm.done)?_c('CheckMail',{attrs:{"title":"It’s not the same without you!","subTitle":"While we're sorry to see you go. We'll be here waiting to help you get reacquainted."}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }